// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1ho_4","disabled":"FileBtn_disabled__1pbm-","warn":"FileBtn_warn__2qsEU","fade":"FileBtn_fade__2eDEP"};